import { NO_CLIENT } from "@/features/projects/lib/pickerOptions";
import { useT } from "@/shared/i18n/useT";
import { Combobox, type ComboboxOption } from "@/shared/ui/Combobox";
import { Field, describedBy } from "@/shared/ui/Field";

interface ClientFieldProps {
  /** A client id, or NO_CLIENT for an internal project. */
  value: string;
  onChange: (value: string) => void;
  options: readonly ComboboxOption[];
  loading?: boolean;
  disabled?: boolean;
  error?: string;
}

/** Which client the project is for, or none (an internal project). */
export function ClientField({
  value,
  onChange,
  options,
  loading,
  disabled,
  error,
}: ClientFieldProps) {
  const t = useT();
  return (
    <Field id="project-client" label={t("newProject.client")} error={error}>
      <Combobox
        size="md"
        options={options}
        value={value}
        onChange={(next) => {
          onChange(next ?? NO_CLIENT);
        }}
        placeholder={t("newProject.noClient")}
        searchPlaceholder={t("newProject.clientSearch")}
        emptyLabel={t("newProject.clientEmpty")}
        disabled={loading === true || disabled === true}
        {...describedBy("project-client", error)}
      />
    </Field>
  );
}
